export default (event) => {
    const eventName = event.eventName;
    const counterId = event.counterId;
    delete event.eventName;
    delete event.counterId;
    if (!counterId) {
        console.info(`%c YaMetric Ошибка: необходимо указать counterId`, "color: #f44336; font-weight: bold;", event);
        return;
    }
    if (localStorage.getItem("mg_aed")) {
        console.info(`%c YaMetric: ${eventName}`, "color: #4caf50; font-weight: bold;", event);
    }
    if (typeof ym !== "undefined") {
        ym(counterId, "reachGoal", eventName, event);
    }
};
